module.exports = __webpack_public_path__ + "img/menuItem_bg_on.733ffbe4.png";